<template>

    <div>
        <!--<button @click="geolocate">Usar a minha localização</button>-->
        <gmap-map :center="center" :zoom="zoom"
                  @center_changed="updateReportedData" @zoom_changed="updateZoom"
                  class="map-container"
                  fill-height>
            <gmap-marker
                    :key="index" v-for="(m, index) in markers"
                    :position="m.position" :title="m.title"
                    @click="selectMarker(m)"
            ></gmap-marker>
        </gmap-map>

        <!--<div> {{ center.lat}} |{{ center.lng}}</div>-->
        <!--<div> {{ reportedMapCenter.lat}} |{{ reportedMapCenter.lng}}</div>-->
        <!--<div> {{zoom}}</div>-->

        <!--Under the map with the various locations of all the stores, there is a section which content depends on the -->
        <!--selected store on the map. -->
        <!--If the user selects a store on the map:-->
        <!--1 - if the store has an image, a card is displayed with the store's image, name and a link to access the store's detail;-->
        <!--2 - if the store has no image, a list is displayed with the store's name and a link to access the store's detail.-->

        <v-hover v-show="store.show">
            <v-card v-if="store.image" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`">

                <v-img v-if="store.image && baseUrl"
                       v-bind:src="baseUrl + store.image"
                       height="100px"
                ></v-img>

                <!--In case we want to revert what is mentioned on point 2-->
                <!--(2 - if the store has no image, a list is displayed with the store's name and a link to access the store's detail.)-->
                <!--    this is ready to display the default image when the entity has not a defined image-->
                <!--<v-img v-else v-bind:src="'/img/noStore.png'" height="200px"></v-img>-->

                <v-card-actions class="pa-2">
                    {{ store.name }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="$parent.goToDetail(store.id)" class="mr-0">
                        <v-icon color="primary">fal fa-angle-double-right</v-icon>
                    </v-btn>
                </v-card-actions>

                <!--<v-card-title>
                    <div>
                        <span class="headline" v-text="store.name"></span>
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="$parent.goToDetail(store.id)" class="mr-0">
                        <v-icon color="primary">fal fa-angle-double-right</v-icon>
                    </v-btn>
                </v-card-title>-->

            </v-card>
            <v-list v-else>
                <v-list-tile @click="$parent.goToDetail(store.id)">
                    <v-list-tile-content>
                        <v-list-tile-title>{{ store.name }}</v-list-tile-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                        <v-btn icon @click="$parent.goToDetail(store.id)" class="mr-0">
                            <v-icon color="primary">fal fa-angle-double-right</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>

                <v-divider color="primary"></v-divider>
            </v-list>
        </v-hover>
    </div>

</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "StoresMaps",
    data() {
        return {
            // default to Porto
            zoom: 5,
            reportedZoom: 5,
            center: {lat: 41.180, lng: -8.590},
            reportedMapCenter: {lat: 41.180, lng: -8.590},
            store: {},
        };
    },
    computed: {
        markers() {
            let stores = this.$parent.stores;
            let store_markers = [];
            for (let idx in stores) {
                if (stores[idx].map_latitude && stores[idx].map_longitude) {
                    store_markers.push({
                        id: stores[idx].id,
                        title: stores[idx].name,
                        position: {
                            lat: parseFloat(stores[idx].map_latitude),
                            lng: parseFloat(stores[idx].map_longitude)
                        }
                    })
                }
            }
            return store_markers
        },
        ...mapGetters({
            baseUrl: 'configs/apiImgBaseUrl',
        }),
    },
    mounted() {
        this.geolocate();
    },

    methods: {
        // receives a place object via the autocomplete component
        setPlace(place) {
            this.currentPlace = place;
        },
        updateReportedData(latLng) {
            this.store.show = 0;
            this.reportedMapCenter = {
                lat: latLng.lat(),
                lng: latLng.lng(),
            };
        },
        updateZoom(zoom) {
            this.zoom = zoom
        },
        selectMarker(marker) {
            this.center = marker.position;

            let id = parseInt(marker.id);
            this.store = this.$parent.getStoreById(id);
            this.store.show = 1;
            this.zoom = 12;
        },
        geolocate: function () {
            this.center = this.reportedMapCenter;
            this.zoom = 5;
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                this.zoom = 6;
            });
        }
    }

}
</script>

<style scoped>
.map-container {
    width: 100%;
    height: 400px;
    display: inline-block;
}
</style>